import { mixed, object, string } from "yup";

export const addFilingDetailsValidation = object().shape({
  payment_schedule: string().required("Please select payment schedule"),
  sales_tax_id: mixed().required("Sales tax ID is required"),
  filing_start_date: string().required("Filing start date is required"),
});
